import ProjectSession from "../../project-session";


export function projectLinkGoTo(project: ProjectSession) {

    if (project.properties.url) {
        const isFullLink = project.properties.url.substring(0,4) === 'http'

        window.open('{0}{1}'.f(isFullLink ? '' : 'https://', project.properties.url))

    } else {

        if (project.acl.hasFullAccess) {
            gd.navigation.goToProject(project.id, '/link/edit')
        } else {
            gd.growl.error("No link URL specified.")
        }


    }

}